$('body').on('click', '.plum_product_option_swatches', async function() {
    const product_handle = $(this).data("product_handle");
    const metal_type_handle = $(this).data("metal_type_handle"); 
    const mainParentProductId = $(this).closest('.grid__item').data('product-id');    
    const mainParentElement = $(this).closest('.grid__item').attr('id');
    const swatchesParentElement = `#${mainParentElement} .plum_product_option_swatches_ul`;
    const wishlistElemet = `#${mainParentElement} .plum_product_add_to_wishlist`;
    const productVendorElement = `#${mainParentElement} .plum_product_product_vendor`;
    const productTitleElement = `#${mainParentElement} .plum_product_product_information_text a`;
    const productCollectionTitleElement = `#${mainParentElement} .plum_product_collection_title`;
    const productPriceElement = `#${mainParentElement} span.price-item.price-item--regular.gt_reg`;
    const productImgElement = `#${mainParentElement} .plum_product_featured_image`;
    const productImgMediaElement = `#${mainParentElement} .plum_product_media_images`;
    const productCardConentLinkElement = `#${mainParentElement} .plum_product_card_conent a`;
    const productBadgeElement = `#${mainParentElement} .plum_product_product_badge`;
    
    try {
        const respData = await getProductInfo(product_handle);
        if (respData?.SUCCESS === 'TRUE') {
            const productData = respData?.DATA;
    
            const productLegacyResourceId = productData?.legacyResourceId;
            const productVendor = productData?.vendor || '';
            const productFeaturedImage = productData?.featuredImage?.url || '#';
            const productTitle = productData?.title || '';
            const productHandle = productData?.handle || '';
            const productTags = productData?.tags || [];
            const productPrice = productData?.variants?.edges[0]?.node?.price || '';
            const productVariantLegacyResourceId = productData?.variants?.edges[0]?.node?.legacyResourceId || '';
            const productMediaImages = productData?.images?.edges || [];

            //#region : Generate Swatches
            const metalTypeProdMetafield = productData?.metafields?.edges.find(edge => edge?.node?.key === "metal-type-with-products");
            if (metalTypeProdMetafield) {
                const metalTypeProdMetafieldValue = metalTypeProdMetafield?.node?.value;
                const metalTypeProdArray = metalTypeProdMetafieldValue.split(',');
        
                const generatedSwatchesHtml = generateSwatchesHtml(metalTypeProdArray,product_handle);
        
                $(`${swatchesParentElement}`).html(generatedSwatchesHtml);
            }else{
                $(`${swatchesParentElement}`).html('');
            }
            //#endregion

            //#region : Change In Wishlist
            $(wishlistElemet).removeClass(function(index, classNames) {
                return classNames.split(' ').filter(className => className.startsWith('product_')).join(' ');
            }).addClass(`product_${productLegacyResourceId}`).attr('data-product-id', productLegacyResourceId).attr('data-variant-id',productVariantLegacyResourceId).attr('data-product-url',`https://www.plumdiamonds.com/products/${productHandle}`);
            $(wishlistElemet).removeClass('disabled');
            $(wishlistElemet).removeClass('swym-added');
            if(window._swat){
                _swat.initializeActionButtons("Body");
            }
            //#endregion

            //#region : Change Vendor
            // $(productVendorElement).text(productVendor);
            //#endregion

            //#region : Change In Title & Link
            $(productTitleElement).attr("href", `/products/${productHandle}`);
            $(productTitleElement).text(productTitle);
            //#endregion

            //#region : Change Collection Title
            const productShortNameMetafield = productData?.metafields?.edges.find(edge => edge?.node?.key === "product_short_names") || '';
            $(productCollectionTitleElement).text(productShortNameMetafield?.node?.value || '');
            //#endregion

            //#region : Change In Product Price
            const isDiaSearchTag = productTags.some(tag => tag.includes("DiaSearch"));
            $(productPriceElement).text(moneyFormater(productPrice) + (isDiaSearchTag ? '+' : ''));
            //#endregion

            //#region : Change In Image
            $(productImgElement).attr("src", productFeaturedImage);
            let srcset = "";
            srcset += `${productFeaturedImage}&width=165 65w,`;
            srcset += `${productFeaturedImage}&width=360 60w,`;
            srcset += `${productFeaturedImage}&width=533 33w,`;
            srcset += `${productFeaturedImage}&width=720 20w,`;
            srcset += `${productFeaturedImage}&width=940 40w,`;
            srcset += `${productFeaturedImage}&width=1066 1066w,`;
            srcset.slice(0, -1);
            $(productImgElement).attr("srcset", srcset);
            //#endregion

            //#region : Change In Image Link
            $(productCardConentLinkElement).attr("href", `/products/${productHandle}`);
            //#endregion

            //#region : Change In Badge
            const badgeTag = productTags.find(tag => tag.includes("_badge_"));
            if (badgeTag) {
                const formattedBadgeTag = badgeTag.replace("_badge_", "").replace(/_/g, ' ');
                $(productBadgeElement).text(formattedBadgeTag);
            }else{
                $(productBadgeElement).text('');
            }
            //#endregion

            //#region : Change in Image Media
            if(productMediaImages.length > 0){
                let srcset = '';
                let imgSrc = productMediaImages[0]?.node?.url;
                let imgHeight = productMediaImages[0]?.node?.height;
                let imgWidth = productMediaImages[0]?.node?.width;
                for (const singleImageInfo of productMediaImages) {
                    let url = singleImageInfo?.node?.url;
                    let width = singleImageInfo?.node?.width;
                    let height = singleImageInfo?.node?.height;

                    if (width >= 165){
                        srcset += `${url}&width=165 65w,`;
                    }
                    if (width >= 360){
                        srcset += `${url}&width=360 60w,`;
                    }
                    if (width >= 533){
                        srcset += `${url}&width=533 33w,`;
                    }
                    if (width >= 720){
                        srcset += `${url}&width=720 20w,`;
                    }
                    if (width >= 940){
                        srcset += `${url}&width=940 40w,`;
                    }
                    if (width >= 1066){
                        srcset += `${url}&width=1066 1066w,`;
                    }
                    srcset += `${url}&width=${width}w,`;
                }
                srcset.slice(0, -1);
                $(productImgMediaElement).attr("srcset", srcset);
                $(productImgMediaElement).attr("src", imgSrc);
                $(productImgMediaElement).attr("height", imgHeight);
                $(productImgMediaElement).attr("width", imgWidth);
                $(productImgMediaElement).show();
            }else{
                $(productImgMediaElement).hide();
            } 
            //#endregion
        } else {
            console.log(respData);
        }
    } catch (error) {
        console.log(error);
    }
});
  
const getProductInfo = async (product_handle) => {
    const url = '/apps/plum-app/process_on_request.php';
    const settings = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'action':'get_product_info_by_handle',
            'shop': Shopify.shop,
            'product_handle': product_handle
        })
    };
    try {
        const fetchResponse = await fetch(url, settings);
        if (!fetchResponse.ok) {
            throw new Error(`HTTP error! Status: ${fetchResponse.status}`);
        }
        const data = await fetchResponse.json();
        return data;
    } catch (error) {
        return error;
    }
};

const moneyFormater = (cents, format = "${{amount_no_decimals}}") => {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
    }

    const match = formatString.match(placeholderRegex);
    if (match) {
        const placeholder = match[1];
        switch (placeholder) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }
    }

    return formatString.replace(placeholderRegex, value);
};

const generateSwatchesHtml = (metalTypeProdArray,product_handle) => {
    const swatchData = {
        rose_gold: {
            dataValue: "14k Rose Gold",
            imgUrl: "https://image.plumdiamonds.com/Shopify%20Plum%20Diamonds/Product%20Images/attribute-imgs/metal-color-14k-rose-gold.png?format=webp",
        },
        yellow_gold: {
            dataValue: "18k Yellow Gold",
            imgUrl: "https://image.plumdiamonds.com/Shopify%20Plum%20Diamonds/Product%20Images/attribute-imgs/metal-color-18k-yellow-gold.png?format=webp",
        },
        platinum: {
            dataValue: "Platinum",
            imgUrl: "https://image.plumdiamonds.com/Shopify%20Plum%20Diamonds/Product%20Images/attribute-imgs/metal-color-platinum.png?format=webp",
        },
        white_gold: {
            dataValue: "White Gold",
            imgUrl: "https://image.plumdiamonds.com/Shopify%20Plum%20Diamonds/Product%20Images/attribute-imgs/metal-color-platinum.png?format=webp",
        },
        yellow_platinum: {
            dataValue: "18k Yellow & Platinum",
            imgUrl: "https://image.plumdiamonds.com/Shopify%20Plum%20Diamonds/Product%20Images/attribute-imgs/metal-color-18k-yellow-platinum.png?format=webp",
        },
        rose_platinum: {
            dataValue: "14k Rose & Platinum",
            imgUrl: "https://image.plumdiamonds.com/Shopify%20Plum%20Diamonds/Product%20Images/attribute-imgs/metal-color-14k-rose-platinum.png?format=webp",
        },
    };
  
    let swatchesHtml = '';

    // Sorting Based On Metal Type Order
    const metalTypeOrder = [
        "white_gold",
        "yellow_gold",
        "rose_gold",
        "yellow_platinum",
        "rose_platinum",
        "platinum"
    ];
    metalTypeProdArray.sort((a, b) => {
        const metalTypeA = a.split(":")[0];
        const metalTypeB = b.split(":")[0];
        return metalTypeOrder.indexOf(metalTypeA) - metalTypeOrder.indexOf(metalTypeB);
    });

    for (const element of metalTypeProdArray) {
        const [metalColor, prodHandle] = element.split(":");
    
        if (metalColor && prodHandle && swatchData[metalColor]) {
            const { dataValue, imgUrl } = swatchData[metalColor];
            
            let activeClass = '';
            if(product_handle == prodHandle){
                activeClass = ' active-color';
            }

            swatchesHtml += `
                <li class="plum_product_option_swatches${activeClass}" data-metal_type_handle="${metalColor}" data-product_handle="${prodHandle}">
                    <div class="img_border" data-value="${dataValue}">
                        <img src="${imgUrl}">
                    </div>
                </li>`;
        }
    }
  
    return swatchesHtml;
};